class AfterFourHeader extends HTMLElement {}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-af-header]');
  if (!header) return;
  const toggle = header.querySelector('[data-af-menu-toggle]');
  const menu = header.querySelector('[data-af-menu]');
  const shopMenu = header.querySelector('.af-shop-menu');
  let shopCloseTimer;
  const close = () => {
    header.classList.remove('is-menu-open');
    toggle?.setAttribute('aria-expanded', 'false');
    if (shopMenu) shopMenu.open = false;
  };

  toggle?.addEventListener('click', () => {
    const open = !header.classList.contains('is-menu-open');
    header.classList.toggle('is-menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  shopMenu?.addEventListener('pointerenter', () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    window.clearTimeout(shopCloseTimer);
    shopMenu.open = true;
  });
  shopMenu?.addEventListener('pointerleave', () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    shopCloseTimer = window.setTimeout(() => { shopMenu.open = false; }, 170);
  });
  shopMenu?.addEventListener('focusin', () => window.clearTimeout(shopCloseTimer));
  shopMenu?.addEventListener('focusout', () => {
    shopCloseTimer = window.setTimeout(() => {
      if (!shopMenu.contains(document.activeElement)) shopMenu.open = false;
    }, 0);
  });
  document.addEventListener('click', (event) => {
    if (shopMenu?.open && !shopMenu.contains(event.target)) shopMenu.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  const syncBagCountFromDrawer = () => {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return;

    const badge = drawer.querySelector('.theme-drawer__badge');
    const drawerIsEmpty = Boolean(drawer.querySelector('.cart-drawer--empty'));
    const parsedCount = Number.parseInt(badge?.textContent?.trim() || '', 10);
    const count = Number.isFinite(parsedCount) ? parsedCount : drawerIsEmpty ? 0 : null;
    if (count === null) return;

    document.querySelectorAll('.af-site-header__actions [aria-controls="cart-drawer"]').forEach((control) => {
      const nextLabel = `BAG (${count})`;
      if (control.textContent?.trim() !== nextLabel) control.textContent = nextLabel;
    });
  };

  syncBagCountFromDrawer();
  const cartCountObserver = new MutationObserver(syncBagCountFromDrawer);
  cartCountObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

  const footer = document.querySelector('.after-four-footer');
  const footerToggles = [...(footer?.querySelectorAll('[data-af-footer-toggle]') || [])];
  if (footer && footerToggles.length) {
    footer.classList.add('is-accordion-ready');
    footerToggles.forEach((button) => {
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.closest('.after-four-footer__column')?.classList.toggle('is-open', open);
        const icon = button.querySelector('i');
        if (icon) icon.textContent = open ? '−' : '+';
      });
    });
  }
});
